import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=d79beb4e&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79beb4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d79beb4e')) {
      api.createRecord('d79beb4e', component.options)
    } else {
      api.reload('d79beb4e', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=d79beb4e&scoped=true", function () {
      api.rerender('d79beb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/Dashboard.vue"
export default component.exports